import React, {Component} from 'react'
import LinkWithTooltip from '../../tooltip';

class Text extends Component {

  onChangeHandle(event){
    const { input: { value, onChange, name } } = this.props
    onChange(event.target.value);
  }

  render(){
    const { input, params } = this.props;

    let placeholder = params.placeholder || '';

    return(
      <div className="sp-pagebuilder-form-group">
        <label>
          { params.title }
          {
            typeof params.desc != 'undefined' && params.desc != '' &&
            <LinkWithTooltip tooltip={params.desc} position="top" title={params.title}>
              <i className="fa fa-question-circle" />
            </LinkWithTooltip>
          }
        </label>
        <input {...input} type="text" placeholder={placeholder} className="sp-pagebuilder-form-control sp-pagebuilder-addon-input" autoComplete="off" onChange={ this.onChangeHandle.bind(this) } />
      </div>
    )
  }
}

export default Text;



// WEBPACK FOOTER //
// ./src/helpers/form/types/Text.js